import { useNavigate, useParams } from 'react-router-dom'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import i18n from 'modules/core/lib/i18n'

import ArchiveQuestionConfigModal from 'modules/surveys/components/Questions/ArchiveQuestionConfigModal'

const SurveyUnarchiveQuestionPage = () => {
  const { navigation } = useNavigation()

  const { id, question_config_id } = useParams()
  const navigate = useNavigate()

  return (
    <ArchiveQuestionConfigModal
      description={i18n.t('surveys.form.unarchive.description')}
      formId={id ?? ''}
      questionConfigId={question_config_id ?? ''}
      submit={i18n.t('surveys.form.unarchive.submit')}
      title={i18n.t('surveys.form.unarchive.title')}
      onClose={() =>
        navigate(navigation.processes.surveys.id.questions.fullPath({ id: String(id) }))
      }
    />
  )
}

export default SurveyUnarchiveQuestionPage
